import React from 'react';
import { TextOverflow, ArrowLeftIcon } from "@forge/common";
import { CREATE_COURSE_CONSTANTS } from "../utils/constants";

interface CreateCourseHeaderProps {
    isEditMode: boolean;
    courseName: string;
    onBackLinkClick: () => void;
}

const CreateCourseHeader: React.FC<CreateCourseHeaderProps> = ({
    isEditMode,
    courseName,
    onBackLinkClick
}) => {
    return (
        <div className="header-bar mb-4">
            {isEditMode ? (
                <TextOverflow
                    lines={1}
                    className="create-course-pageTitle xl-low:!max-w-[835px]"
                    resizeDebounceDelay={100}
                    tooltipPosition="top"
                >
                    {`${CREATE_COURSE_CONSTANTS.PAGE_TITLE_EDIT} - ${courseName}`}
                </TextOverflow>
            ) : (
                <TextOverflow
                    lines={1}
                    className="create-course-pageTitle xl-low:!max-w-[835px] xl-mid:!max-w-none xl-high:!max-w-none"
                    resizeDebounceDelay={300}
                    tooltipPosition="top"
                >
                    {`${CREATE_COURSE_CONSTANTS.PAGE_TITLE_CREATE}`}
                </TextOverflow>
            )}
            <p className="back-link cursor-pointer" id='back-to-library-mngmnt' data-testid='back-to-library-mngmnt' onClick={onBackLinkClick}>
                <ArrowLeftIcon />{CREATE_COURSE_CONSTANTS.BACK_LINK_TEXT}
            </p>
        </div>
    );
};

export default CreateCourseHeader;